import type { Locale } from '../i18n/config';

export const isGenAiLogomakerAvailable = (locale: Locale) => {
    const availableLocales: Locale[] = [
        'en-US',
        'en-CA',
        'en-GB',
        'en-AU',
        'en-IE',
        'en-NZ',
        'en-SG',
        'de-DE',
        'fr-FR',
        'fr-CA',
    ];
    return availableLocales.includes(locale);
};

export const isBNGAvailable = (locale: Locale) => {
    const availableLocales: Locale[] = [
        'en-US',
        'en-CA',
        'en-GB',
        'en-AU',
        'en-IE',
        'en-NZ',
        'en-SG',
    ];
    return availableLocales.includes(locale);
};

export const isBusinessNameIdeasAvailable = (locale: Locale) => {
    const availableLocales: Locale[] = ['en-US'];
    return availableLocales.includes(locale);
};

export const isBrandKitAvailable = (locale: Locale) => {
    const availableLocales: Locale[] = [
        'en-US',
        'en-AU',
        'en-CA',
        'en-GB',
        'en-IE',
        'en-SG',
        'en-NZ',
    ];
    return availableLocales.includes(locale);
};

export const isVistaXWixAvailable = (locale: Locale) => {
    const availableLocales: Locale[] = [
        'en-US',
        'en-CA',
        'en-GB',
        'en-AU',
        'en-IE',
        'en-NZ',
        'en-SG',
        'de-DE',
        'de-AT',
        'de-CH',
        'fr-FR',
        'fr-CA',
        'fr-CH',
        'fr-BE',
        'it-IT',
        'it-CH',
        'nl-NL',
        'nl-BE',
        'es-US',
        'es-ES',
        'pt-PT',
        'da-DK',
        'nb-NO',
        'sv-SE',
    ];
    return availableLocales.includes(locale);
};

export const isVistaCreateAvailable = (locale: Locale) => {
    const availableLocales: Locale[] = [
        'en-US',
        'en-CA',
        'en-GB',
        'en-AU',
        'en-IE',
        'en-NZ',
        'en-SG',
        'de-DE',
        'de-AT',
        'de-CH',
        'fr-FR',
        'fr-CA',
        'fr-CH',
        'fi-FI',
    ];
    return availableLocales.includes(locale);
};
